<template>
 <div class="loading-wrap">
   <div class="loading-graphics">
       <img src="https://cloud.aleacontrol.com/media/vSoccer/loading.png" alt="">
   </div><div class="loader-bar-wrap">
      <div class="loader-bar">
         <object :width="loadedPercentage+'%'"></object>
      </div>
   </div>
</div>
</template>
<style lang="scss">

</style>
<script>
import { eventBus } from '@/main.js'
import EventConstants from '@/constants/Events'

export default {
  props: {
    authComplete: {
      type: Boolean,
      required: true,
      default: false
    },
    allGames: {
      type: Array,
      required: false
    }
  },
  methods: {
    onLoadingCompleted: function () {
      eventBus.onLoadingComplete()
    },
    onEventSoccerLoaded: function () {
      this.soccerComponentLoaded = true
    },
    onEventDogsLoaded: function () {
      this.dogsComponentLoaded = true
    }
  },
  data () {
    return {
      loaded: false,
      loadedPercentage: 0,
      soccerComponentLoaded: false,
      dogsComponentLoaded: false
    }
  },
  created: function () {
    eventBus.$on(EventConstants.VSOCCER_COMPONENT_LOAD_COMPLETE, this.onEventSoccerLoaded)
    eventBus.$on(EventConstants.VDOG_COMPONENT_LOAD_COMPLETE, this.onEventDogsLoaded)
  },
  beforeDestroy () {
    eventBus.$off(EventConstants.VSOCCER_COMPONENT_LOAD_COMPLETE, this.onEventSoccerLoaded)
    eventBus.$off(EventConstants.VDOG_COMPONENT_LOAD_COMPLETE, this.onEventDogsLoaded)
  },
  mounted: function () {
    let percentageCalculation = setInterval(() => {
      if (this.loadedPercentage >= 100) {
        clearInterval(percentageCalculation)
        this.onLoadingCompleted()
      } else if (this.loadedPercentage === 50) {
        if (this.allGames != null) {
          if (this.soccerComponentLoaded && this.allGames[0].gameName === 'VFootball') {
            this.loadedPercentage = ++this.loadedPercentage
          } else if (this.dogsComponentLoaded && this.allGames[0].gameName === 'VDogs') {
            this.loadedPercentage = ++this.loadedPercentage
          }
        }
      } else {
        this.loadedPercentage = ++this.loadedPercentage
      }
    }, 16)
  }
}
</script>
